import React, { useState } from "react";
import styled from "styled-components";
import AppLink from "components/common/style/link/AppLink";
import DeleteText from "components/common/style/navigation/DeleteText";
import { usePhotoSeriesSearch } from "hooks/citajteo/photo_series/usePhotoSeriesSearch";
import { usePhotoSeriesDelete } from "hooks/citajteo/photo_series/usePhotoSeriesDelete";
import { QUERY_KEYS } from "constant/react_query";
import { PhotoSeries } from "model/photo_series/PhotoSeries";
import toast from "react-hot-toast";
import ConfirmModal from "components/UI/modal/ConfirmModal";
import PhotoSeriesEditNav from "components/admin/common/photo_series/nav/PhotoSeriesEditNav";

const PhotoSeriesList: React.FC = () => {
  const photoSeries = usePhotoSeriesSearch();
  const { photoSeriesDeleteMutate } = usePhotoSeriesDelete({
    invalidateKeys: [QUERY_KEYS.CITAJTEO_PHOTO_SERIES_SEARCH],
  });
  const [photoSeriesToDelete, setPhotoSeriesToDelete] =
    useState<PhotoSeries | null>(null);

  const handlePhotoSeriesDelete = (item: PhotoSeries) => {
    setPhotoSeriesToDelete(item);
  };

  const handleConfirmDelete = () => {
    if (!photoSeriesToDelete) {
      return;
    }

    const item = photoSeriesToDelete;
    photoSeriesDeleteMutate(item.id, {
      onSuccess: () => {
        toast.success("Uspešno brisanje foto serije.");
        setPhotoSeriesToDelete(null);
      },
      onError: (error) => {
        console.error("Error deleting photo series:", error);
        toast.error("Greška prilikom brisanja foto serije.");
        setPhotoSeriesToDelete(null);
      },
    });
  };

  return (
    <Content>
      <ContentInner>
        <NewItem>
          <AppLink to="/admin-dashboard/photo-ser-new">novo</AppLink>
        </NewItem>

        {photoSeries?.items?.length > 0 &&
          photoSeries.items.map((item: PhotoSeries) => (
            <ListItem key={item.id}>
              <PhotoSeriesEditNav photoSer={item} />
              {item.name || item.slug}
              <Meta>{item.group}</Meta>
              <DeleteItem>
                <DeleteText onClick={() => handlePhotoSeriesDelete(item)}>
                  obriši
                </DeleteText>
              </DeleteItem>
            </ListItem>
          ))}
      </ContentInner>
      <ConfirmModal
        open={photoSeriesToDelete !== null}
        title="Brisanje foto serije"
        message={
          photoSeriesToDelete
            ? `Da li želite da obrišete foto seriju ${photoSeriesToDelete.name || photoSeriesToDelete.slug}?`
            : ""
        }
        confirmLabel="Obriši"
        cancelLabel="Otkaži"
        onConfirm={handleConfirmDelete}
        onCancel={() => setPhotoSeriesToDelete(null)}
      />
    </Content>
  );
};

export default PhotoSeriesList;

const Content = styled.div``;

const ContentInner = styled.div`
  width: 90%;
`;

const NewItem = styled.div`
  margin-top: 0;
`;

const ListItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1em;
  gap: 0.5rem;
  width: 100%;
`;

const Meta = styled.div`
  color: #666;
  font-size: 0.9em;
`;

const DeleteItem = styled.div`
  margin-top: 0.5rem;
`;
